import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class SharedService {

  private sharedData: Subject<any> = new Subject<any>();
  sharedData$: Observable<any> = this.sharedData.asObservable();

  private sharedsetDataTelemetryReload: Subject<any> = new Subject<any>();
  sharedsetDataTelemetryReload$: Observable<any> = this.sharedsetDataTelemetryReload.asObservable();

  constructor() { }

  setData(updatedData) {
    this.sharedData.next(updatedData);
  }

  setDataTelemetryReload(updatedData){
    this.sharedsetDataTelemetryReload.next(updatedData);
  }

}